import React from 'react';
import { Brain, Code, Server } from 'lucide-react';
import theme from '../../constants/theme';

export default function About() {
  return (
    <section id="about" className="py-24 relative" style={{ backgroundColor: 'white' }}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Story Text */}
          <div>
            <h2 className="font-retropix text-3xl md:text-4xl mb-8" style={{ color: theme.primary }}>
              The Story
            </h2>
            <div className="space-y-6 text-base leading-relaxed">
              <p>
                A couple of months ago, two AI engineers sat down and asked themselves a simple question:
                <strong className="block mt-2 font-retropix text-sm" style={{ color: theme.primary }}>
                  "We've spent years building AI for everyone else. What if we built something of our own?"
                </strong>
              </p>
              <p>
                No grand plan. No big corporate office. Just two people who had done the 9-to-5 long enough to know they wanted more—and believed they had the technical depth to go do it.
              </p>
              <p>
                That conversation became <strong>MiraAI.SOL</strong>.
              </p>
              <p>
                Backed by 4+ years of real-world AI experience, published IEEE research, and extensive consulting for MNCs, we bridge the gap between academic AI research and scalable, production-ready systems.
              </p>
            </div>
          </div>

          {/* Foundation Box */}
          <div className="border-4 p-8 relative" style={{ borderColor: theme.primary }}>
            <div
              className="absolute -top-5 left-8 px-4 font-retropix text-xl"
              style={{ backgroundColor: 'white', color: theme.primary }}
            >
              The Foundation
            </div>
            <ul className="space-y-6 mt-4">
              <li className="flex items-start gap-4">
                <Brain size={24} style={{ color: theme.primary }} className="mt-1 flex-shrink-0" />
                <div>
                  <h3 className="font-bold uppercase tracking-wide">4+ Years Experience</h3>
                  <p className="text-sm opacity-80 mt-1">Deep Learning, CV, NLP across diverse domains.</p>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <Code size={24} style={{ color: theme.primary }} className="mt-1 flex-shrink-0" />
                <div>
                  <h3 className="font-bold uppercase tracking-wide">Research to Production</h3>
                  <p className="text-sm opacity-80 mt-1">IEEE published expertise applied to scalable pipelines.</p>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <Server size={24} style={{ color: theme.primary }} className="mt-1 flex-shrink-0" />
                <div>
                  <h3 className="font-bold uppercase tracking-wide">End-to-End Stack</h3>
                  <p className="text-sm opacity-80 mt-1">From custom LLMs to on-device Android deployment.</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
